const SessionFilter = ({value, onChange, style = {}, disabled = false}) => (
  <select
    name='session'
    style={{width: '150px', height: '40px', cursor: disabled ? 'not-allowed' : 'pointer', ...style}}
    className='form-control rounded'
    value={value}
    disabled={disabled}
    onChange={e => onChange(e.target.value)}>
    <option value=''>Session</option>
    <option value='morning'>Morning</option>
    <option value='evening'>Evening</option>
  </select>
);

export default SessionFilter;
